const caseAlertsStyle = {
  caseAlert: {
    textAlign: "center",
    color: "red",
    fontSize: "1rem",
    paddingBottom: "1rem",
  },
};
export default caseAlertsStyle;
